import { inject } from "vue"
import { FormContextKey, type FormApi } from "../types"

export function useFormContext<T = unknown>(): FormApi<T> {
  const api = inject(FormContextKey)
  if (!api) {
    throw new Error(
      "useFormContext() must be called inside a <FormShell> component."
    )
  }
  return api as FormApi<T>
}
